import React, { useState, useEffect } from 'react';
import './FloatingButtons.css';
import { fetchFloatingButtonData } from '../services/api';

const FloatingButtons = () => {
  const [btnData, setBtnData] = useState({
    phoneNumber: "+919810554007",
    whatsappNumber: "919810554007",
    whatsappMessage: "Hello, I need information about your services"
  });

  useEffect(() => {
    fetchFloatingButtonData().then(data => {
      if (data) {
        setBtnData({
          phoneNumber: data.phoneNumber || "+919810554007",
          whatsappNumber: data.whatsappNumber || "919810554007",
          whatsappMessage: data.whatsappMessage || "Hello, I need information about your services"
        });
      }
    });
  }, []);
  
  const whatsappLink = `https://wa.me/${btnData.whatsappNumber}?text=${encodeURIComponent(btnData.whatsappMessage)}`;
  const phoneLink = `tel:${btnData.phoneNumber}`;

  const handleClick = (e) => {
    // Ripple effect create karna
    const btn = e.currentTarget;
    const ripple = document.createElement('span');
    const rect = btn.getBoundingClientRect();
    const size = Math.max(rect.width, rect.height);
    const x = e.clientX - rect.left - size / 2;
    const y = e.clientY - rect.top - size / 2;
    
    ripple.style.cssText = `
      position: absolute;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.5);
      width: ${size}px;
      height: ${size}px;
      top: ${y}px;
      left: ${x}px;
      pointer-events: none;
    `;
    
    ripple.classList.add('ripple');
    btn.appendChild(ripple);
    
    setTimeout(() => {
      ripple.remove();
    }, 600);
  };

  return (
    <>
      {/* WhatsApp Button */}
      <a
        href={whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-btn"
        aria-label="WhatsApp Chat"
        title="Chat on WhatsApp"
        onClick={handleClick}
      >
        <svg 
          className="whatsapp-icon" 
          viewBox="0 0 24 24" 
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M12 0C5.373 0 0 5.373 0 12c0 2.126.55 4.126 1.517 5.87L0 24l6.33-1.55A11.94 11.94 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0z"/>
          <path fill="#FFF" d="M19.507 16.307c-.297-.149-1.758-.867-2.031-.967-.273-.1-.472-.15-.673.15-.2.298-.774.967-.949 1.167-.174.199-.349.224-.649.075-.298-.15-1.255-.462-2.39-1.475-.883-.784-1.48-1.761-1.653-2.215-.173-.454-.019-.7.13-.923.144-.22.654-.537.937-.803.233-.222.373-.36.559-.36.186 0 .372.035.52.222.149.186.533.666.584.733.051.067.104.149.017.298-.086.149-.149.223-.298.372-.149.149-.31.31-.445.446-.149.149-.298.31-.128.506.17.198.748.847 1.606 1.376 1.056.662 1.943.88 2.194.975.25.095.396.08.543-.074.149-.154.639-.746.812-.985.173-.239.347-.198.587-.099.239.1 1.508.794 1.767.94.26.149.432.224.498.348.066.124.05.708-.124 1.386-.173.678-.99 1.16-1.39 1.238-.398.078-.93-.057-1.618-.252z"/>
        </svg>
        
        <span className="btn-tooltip">Chat on WhatsApp</span>
      </a>

      {/* Call Button */}
      <a
        href={phoneLink}
        className="call-btn"
        aria-label="Call Now"
        title="Call Now"
        onClick={handleClick}
      >
        <svg 
          className="call-icon" 
          viewBox="0 0 24 24" 
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56-.35-.12-.74-.03-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"/>
        </svg>
        
        <span className="btn-tooltip">Call Now</span>
      </a>
    </>
  );
};

export default FloatingButtons;